import {firebase, firestorePlugin, FireStoreUploader} from "@/init/firebase";
import Vue from "vue";
import store from "@/store";
import MotivateCloudApi from "@/init/initCloudApi";
import isMobile from "@/plugins/isMobile";
import BarcodeScanner from "vue-zebra-barcode-scanner";

export const auth = {
    data() {
        return {}
    },
    methods: {
        async logOutUser() {
            for (let i = 0; i < localStorage.length; i++) {
                const key = localStorage.key(i);
                if (key !== 'lastVersion') {
                    localStorage.removeItem(key);
                }
            }
            await firebase.auth().signOut();
            store.commit('users/setMe', null);
            if (navigator && navigator.app) {
                navigator.app.exitApp();
            }
            location.reload();
            // this.$router.push({name: 'login'});

        },
        async waitForAuthInit() {
            let unsubscribe;
            await new Promise((resolve) => {
                unsubscribe = firebase.auth().onAuthStateChanged((_) => resolve());
            });
            (await unsubscribe)();
        },
        async getCurrentUser() {
            try {
                await this.waitForAuthInit();

                return await firebase.auth().currentUser;
            } catch (err) {
                return null;
            }
        },
        async getClaims(email) {
            const snap = await firebase.firestore().collection('users').doc(email).get();
            return snap.exists ? snap.data() : null;
        },
        async processUser(user, self) {
            let updatedUser = user;
            const idTokenResult = await updatedUser.getIdTokenResult()

            Vue.use(firestorePlugin)

            Vue.prototype.$FB = firebase.firestore()
            Vue.prototype.$FB_STORAGE = firebase.storage()
            Vue.prototype.$FBClient = firebase
            Vue.prototype.$FB_UPLOADER = new FireStoreUploader(firebase.storage());
            const claims = await this.getClaims(idTokenResult.claims.email);

            // console.log("claims", JSON.stringify(claims))

            updatedUser.customClaims = claims;
            updatedUser.customClaims.companyId = claims.selectedCompany;

            // console.log("updatedUser", updatedUser)
            store.commit('users/setMe', updatedUser);

            Vue.prototype.$CLOUD_API = new MotivateCloudApi(updatedUser).getCloudApi();


            let config = (await Vue.prototype.$FB.collection('config').doc(`${updatedUser.customClaims.companyId}`).get()).data();
            store.commit('setConfig', config)
            Vue.prototype.$APP_CONFIG = config;
            if (isMobile.check()) {
                document.addEventListener('deviceready', () => {
                    Vue.prototype.$SCANNER_CONFIG = new BarcodeScanner('com.motivate.scanner', config.scanner ? config.scanner : null);
                }, false);
            } else {
                Vue.prototype.$SCANNER_CONFIG = new BarcodeScanner('com.motivate.scanner', config.scanner ? config.scanner : null);
            }

            window.VueGlobalEventBus.$emit('userLoggedIn');
        },

        async refreshAuth() {
            const self = this;
            let user = await firebase.auth().currentUser
            if (user)
                return firebase.auth().currentUser.getIdTokenResult(true)
                    .then(function (idToken) {
                        // self.processUser(user,self)
                        console.log('USER', user)
                        return idToken;
                    }).catch(error => {
                        console.error(error);
                    });
        },
        async handleAuthChanges() {
            const self = this;


            firebase.auth().onAuthStateChanged(async function (user) {

                if (user) {
                    console.log('USER !!@#!@##!@ ', user)
                    await self.processUser(user, self)
                    setInterval(() => {
                        self.refreshAuth()
                    }, 60000 * 30);
                } else {

                    if (window.location.pathname !== '/login' && window.location.pathname !== '/resetPassword' ) {
                        // self.$router.push('/login');
                        window.location.reload();
                    }
                }
            });
        },
        async reInitFirebase() {
            await this.handleAuthChanges();
        },
        initFireBase(username, password) {

            return new Promise(async (resolve, reject) => {

                firebase.auth().signInWithEmailAndPassword(username, password).then((res) => {
                    this.handleAuthChanges();
                    resolve();
                }).catch(function (error) {
                    reject(error)
                    var errorCode = error.code;
                    var errorMessage = error.message;
                });
            })
        }
    },
    created() {

    }
}


